import React, { PureComponent } from 'react';
import { promotionClickGoogleTag } from '@utils/analytics';
import PropTypes from 'prop-types';
import Icon from '../base_svg-icon/component';
import { Button } from 'audamatic-ui';

import './styles/styles.scss';

class SectionHeader extends PureComponent {
  get promotionTagData() {
    const { title, linkTitle, layout } = this.props;
    return {
      title,
      name: linkTitle,
      creative: '',
      'component-type': layout,
      variant: 'link',
      url: this.link,
    };
  }

  pushGoogleTags = () => {
    this.props.store.pushToDataLayer(promotionClickGoogleTag(this.promotionTagData));
  };

  get subTitle() {
    const { subtitle, incentive } = this.props;

    if (!subtitle && !incentive) {
      return null;
    }

    return (
      <div className="sub-title">
        <span>{subtitle}</span>
        {(!!subtitle && !!incentive) && (<span className="sep">|</span>)}
        <span className="incentive">{incentive}</span>
      </div>
    );
  }

  onClickingLink = (url) => {
    window.location.href = url;
    this.pushGoogleTags();
  };

  render() {
    const { title,  name, url, linkTitle, linkIcon = 'ico-arrow-circle-right', headerClasses = '' } = this.props;

    return (
      <div className={`section-header ${headerClasses}`}>
        <div className="titles">
          <div className="main-titles">
            <h2>{title || name}</h2>
            <div className="section-header-link">
              {(linkTitle && url) && (
                <Button
                  variant="link"
                  size="large"
                  iconLeft={<Icon name={linkIcon} size={150} />}
                  onClick={() => this.onClickingLink(url) }
                  {...this.linkExtraAttributes}
                >
                  {linkTitle}
                </Button>
              )}
            </div>
          </div>
          {this.subTitle}
        </div>
      </div>
    );
  }
}

SectionHeader.propTypes = {
  store: PropTypes.object,
  name: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  incentive: PropTypes.string,
  url: PropTypes.string,
  linkTitle: PropTypes.string,
  linkIcon: PropTypes.string,
  underlined: PropTypes.bool,
  layout: PropTypes.any,
  headerClasses: PropTypes.string,
};

export default SectionHeader;
